var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.07086 0C2.73064 0 0 2.73064 0 6.07086C0 9.41109 2.73064 12.1417 6.07086 12.1417C7.35701 12.1417 8.55188 11.7372 9.53589 11.0481L13.1684 14.6861C13.5869 15.1046 14.2676 15.1046 14.6861 14.6861C15.1046 14.2676 15.1046 13.5869 14.6861 13.1684L11.0481 9.53589C11.7372 8.55175 12.1417 7.35699 12.1417 6.07086C12.1417 2.73064 9.41109 0 6.07086 0V0ZM6.07086 2.14266C8.25334 2.14266 9.99907 3.88844 9.99907 6.07086C9.99907 8.25328 8.25328 9.99907 6.07086 9.99907C3.88844 9.99907 2.14266 8.25328 2.14266 6.07086C2.14266 3.88844 3.88844 2.14266 6.07086 2.14266Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.998b0144c146a3004de3561ad091c713.svg";
export { ForwardRef as ReactComponent };